import React, { Component } from 'react';

import Welcome from '../Welcome/Welcome';
import Fallen from '../Fallen/Fallen';
import Header from "../Header/Header"
import { push, vPush } from "../Services/Analytics"
import Helmet from "react-helmet"

import "./Homepage.scss"

class Homepage extends Component {
  constructor() {
    super();
    this.state = {
      showLoader: false,
    }
    this.showLoader = this.showLoader.bind(this);
    this.shouldScrollTop = false;
  }

  componentDidMount() {
    vPush(window.location.pathname + "?prof=2.News-Fallen", "זיכרון אחרון");
  }


  showLoader() {
    this.setState({
      showLoader: !this.state.showLoader
    })
  }

  render() {
    return (
      <div>
        <Header isArticle={false} />
        <div className="homepage">
          <Helmet>
            <title>זיכרון אחרון - ראשי</title>
          </Helmet>
          <div className="bgpos">
            <Welcome />
            <Fallen shouldScrollTop={this.shouldScrollTop}
              showLoader={this.showLoader}
              isLoading={this.state.showLoader} />
          </div>
        </div>
      </div>
    );
  }
}

export default Homepage;


// WEBPACK FOOTER //
// ./src/Components/Homepage/Homepage.jsx